import React from 'react';
import { Icon } from './Icon.js';
export const IconCirclePauseFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "m9,1C4.5889,1,1,4.5889,1,9s3.5889,8,8,8,8-3.5889,8-8S13.4111,1,9,1Zm-1.5,10.75c0,.4141-.3359.75-.75.75s-.75-.3359-.75-.75v-5.5c0-.4141.3359-.75.75-.75s.75.3359.75.75v5.5Zm4.5,0c0,.4141-.3359.75-.75.75s-.75-.3359-.75-.75v-5.5c0-.4141.3359-.75.75-.75s.75.3359.75.75v5.5Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconCirclePauseFill18.js.map